import { ErrorHandler, Injectable } from '@angular/core';
import { ErrorReportingService } from './error-reporting.service';

/**
 * ErrorHandler global. Substitui o ErrorHandler padrão do Angular para
 * que todo erro não tratado passe pelo coletor, em vez de só virar log.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private reporting: ErrorReportingService) {}

  handleError(error: unknown): void {
    this.reporting.captureException(error);
  }
}
